import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { TextField } from '@/components/TextField';
import { ButtonVariant } from '@/constants';
import { useGiftCards } from './useGiftCards';

export const GiftCardForm = () => {
  const {
    cardNumber,
    handleAddGiftCard,
    handleCardNumberChange,
    helpText,
    isPending,
    pin,
    setPin,
  } = useGiftCards();

  return (
    <Form handleSubmit={handleAddGiftCard}>
      <TextField
        inputMode="numeric"
        label="Card number"
        maxLength={19}
        onChange={handleCardNumberChange}
        pattern="^[\d\s]{19}$"
        type="tel"
        value={cardNumber}
      />
      <TextField
        helpText={helpText?.giftCardPinCode}
        inputMode="numeric"
        label="8-digit pin code"
        maxLength={8}
        onChange={setPin}
        pattern="^\d{8}$"
        type="tel"
        value={pin}
      />
      <Button
        isPending={isPending}
        variant={ButtonVariant.FullWidth}
        type="submit"
      >
        Add
      </Button>
    </Form>
  );
};
